import _ from 'lodash'
import { MutationTree } from 'vuex'
import { Pager } from '@/store/pager.types'
import { Mail, MailsState } from '@/store/mails/types'

const mutations: MutationTree<MailsState> = {
  fetchedMails: (state, payload: {
    pager: Pager,
    mails: Mail[],
  }) => {
    state.pager = payload.pager
    state.mails = payload.mails
  },

  gotMail: (state, mail: Mail) => {
    state.mails = _.uniqBy([
      mail,
      ...state.mails,
    ], 'id')
  },
}

export default mutations
